export default "__VITE_ASSET__BVKOZv5O__"